import {Controller} from 'stimulus';
import {MobileAppHelper} from '../helpers/mobile_app_helper';

export default class extends Controller {
  connect() {
    MobileAppHelper.updateLoginStatus(this.data.get('avatarUrl'));
    MobileAppHelper.updateShoppingCartCount(this.data.get('shoppingCartQuantity') || 0);
  }
}
